import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Typography, Table, Button, Select, Modal, message, Input } from 'antd';
// テーブル強化 PJ Ph.3 拡大: 列リサイズ + ソート + 省略
import {
  PageContainer,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
} from '../../common';

const { Text } = Typography;
const { Option } = Select;
const MailTemplatePage = (props) => {
  // console.log({ props });
  const { user } = props;
  const [value, setValue] = useState('');
  const [templateInfo, setTemplateInfo] = useState([]);
  // テンプレート名での絞り込みキーワード（部分一致）
  const [searchName, setSearchName] = useState('');
  const [surveyInfo, setSurveyInfo] = useState([]);
  // const [tokenInfo, setTokenInfo] = useState();
  // const [questionInfo, setQuestionInfo] = useState([]);
  //const [myUser, setMyUser] = useState([]);
  // let user = useSelector((state) => state.user);
  // const history = useHistory();
  //if (!user.userData) return null;

  //console.log({ myUser });

  //yyyy/mm/dd hh:mm
  const ymdhms = (tdate) => {
    let date = new Date(tdate);
    //console.log({ date });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2)
      // date.getMilliseconds()
    );
  };

  const readDB = async () => {
    try {
      if (!user.userData) return null;
      // console.log(user.userData.isAuth);
      if (user.userData.isAuth) {
        const res = await Axios.get('/api/mailTemplate/');
        const survey = await Axios.get('/api/survey/');

        if (res.data.success) {
          // console.log(res.data.mailTemplate);
          setSurveyInfo(survey.data.survey);
          setTemplateInfo(res.data.mailTemplate);
        } else {
          throw new Error('テンプレート取得に失敗しました。');
        }
      } else {
        throw new Error('ログイン前です。');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ mySurvey });
  }, [user]);

  const editTemplateHandler = async (tInfo, e) => {
    e.preventDefault();
    try {
      props.history.push({
        pathname: '/maketemplate',
        state: tInfo,
      });
    } catch (error) {
      console.log(error);
    }
  };
  // テンプレート削除。配信予約に使用中の場合は、その未配信予約も併せて削除される旨を
  // 実際の予約一覧付きで確認してから削除する。edit_ok=false（システム用）は削除不可。
  const deleteTemplateHandler = async (record, e) => {
    if (e) e.preventDefault();
    try {
      const res = await Axios.get(
        `/api/mailTemplate/${record._id}/reservations`
      );
      const reservations =
        (res.data.success && res.data.reservations) || [];

      const doDelete = async () => {
        try {
          const delRes = await Axios.delete(`/api/mailTemplate/${record._id}`);
          if (delRes.data.success) {
            message.success(
              reservations.length > 0
                ? `テンプレートと未配信予約${delRes.data.deletedReservations}件を削除しました`
                : 'テンプレートを削除しました'
            );
            readDB();
          } else {
            message.error(delRes.data.error || '削除に失敗しました');
          }
        } catch (err) {
          console.log(err);
          message.error(
            (err.response && err.response.data && err.response.data.error) ||
              '削除に失敗しました'
          );
        }
      };

      if (reservations.length > 0) {
        Modal.confirm({
          title: 'このテンプレートは配信予約で使用されています',
          width: 560,
          content: (
            <div>
              <p>
                以下の未配信予約{reservations.length}
                件も同時に削除されます。よろしいですか？
              </p>
              <div
                style={{
                  maxHeight: 200,
                  overflowY: 'auto',
                  border: '1px solid var(--gray-300, #d9d9d9)',
                  borderRadius: 6,
                  padding: '6px 10px',
                }}
              >
                {reservations.map((r, i) => (
                  <div key={i} style={{ padding: '2px 0' }}>
                    {ymdhms(r.send_date_time)}｜{r.group_name || '-'}｜
                    {r.mt_name}
                  </div>
                ))}
              </div>
            </div>
          ),
          okText: 'テンプレートと予約を削除',
          okButtonProps: { danger: true },
          cancelText: 'キャンセル',
          onOk: doDelete,
        });
      } else {
        Modal.confirm({
          title: 'テンプレートを削除しますか？',
          content: `「${record.mt_name}」を削除します。この操作は取り消せません。`,
          okText: '削除',
          okButtonProps: { danger: true },
          cancelText: 'キャンセル',
          onOk: doDelete,
        });
      }
    } catch (error) {
      console.log(error);
      message.error('予約の確認に失敗しました');
    }
  };

  const newTemplateHandler = async (e) => {
    e.preventDefault();
    try {
      props.history.push({
        pathname: '/maketemplate',
        state: {},
      });
    } catch (error) {
      console.log(error);
    }
  };

  const onChangeSurvey = (v) => {
    // クリア（allowClear）時はサーベイ絞り込みを解除
    if (!v) {
      setValue('');
      return;
    }
    const survey = surveyInfo.find((item) => item.survey_code === v);
    setValue({
      ...value,
      survey_code: v,
      survey_id: survey ? survey._id : undefined,
    });
  };

  // 表示行 = 全テンプレートを「サーベイ種類」+「テンプレート名(部分一致)」で絞り込み。
  // 削除/作成後は readDB が templateInfo を更新するため、この派生リストも自動で最新になる。
  const selSurveyCode = (value && value.survey_code) || '';
  const nameKw = searchName.trim().toLowerCase();
  const displayTemplates = templateInfo.filter((item) => {
    if (selSurveyCode && item.survey_code !== selSurveyCode) return false;
    if (nameKw && !(item.mt_name || '').toLowerCase().includes(nameKw))
      return false;
    return true;
  });

  // テーブル強化 PJ Ph.3 拡大: <Column> → columns 配列。テキスト列はソート + 省略、操作列は維持。
  const rawColumns = [
    ellipsisColumn({
      title: 'テンプレート名',
      dataIndex: 'mt_name',
      key: 'mt_name',
      width: 200,
      sorter: textSorter('mt_name'),
    }),
    ellipsisColumn({
      title: 'テンプレート説明',
      dataIndex: 'mt_description',
      key: 'mt_description',
      width: 260,
      sorter: textSorter('mt_description'),
    }),
    ellipsisColumn({
      title: '件名',
      dataIndex: 'subject',
      key: 'subject',
      width: 240,
      sorter: textSorter('subject'),
    }),
    ellipsisColumn({
      title: '差出人名',
      dataIndex: 'from_name',
      key: 'from_name',
      width: 160,
      sorter: textSorter('from_name'),
    }),
    {
      title: '編集',
      key: 'action',
      width: 90,
      render: (text, record) => (
        <span>
          <Button
            size="small"
            disabled={!record.edit_ok}
            onClick={(e) => editTemplateHandler(record, e)}
          >
            編集
          </Button>
        </span>
      ),
    },
    {
      title: '削除',
      key: 'delete',
      width: 90,
      render: (text, record) => (
        <Button
          danger
          size="small"
          // system_key を持つ（回答差戻し通知など）システム固定テンプレートは削除不可
          disabled={!record.edit_ok || !!record.system_key}
          onClick={(e) => deleteTemplateHandler(record, e)}
        >
          削除
        </Button>
      ),
    },
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(rawColumns);

  return (
    <PageContainer fluid>
      <div style={{ marginTop: 16, marginBottom: 16 }}>
          <Text>■絞り込み｜</Text>
          <>
            <Text>サーベイ選択：</Text>
            <Select
              showSearch
              allowClear
              style={{
                width: 300,
              }}
              placeholder="サーベイ選択"
              optionFilterProp="children"
              onChange={onChangeSurvey}
              value={value['survey_code'] || undefined}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {surveyInfo.map((element) => {
                return (
                  <Option value={element.survey_code} key={element._id}>
                    {element.survey_name}
                  </Option>
                );
              })}
            </Select>
            <Text style={{ marginLeft: 16 }}>テンプレート名で検索：</Text>
            <Input
              allowClear
              placeholder="テンプレート名で検索"
              style={{ width: 240 }}
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </>
        </div>
        <div ref={wrapRef}>
          <Table
            columns={columns}
            components={components}
            scroll={scroll}
            dataSource={displayTemplates}
            size="middle"
            rowKey="_id"
            pagination={{
              defaultPageSize: 100,
              showSizeChanger: true,
              pageSizeOptions: ['20', '50', '100', '200'],
            }}
          />
        </div>

        <Button
          type={'primary'}
          size="small"
          onClick={(e) => newTemplateHandler(e)}
        >
          新規テンプレート作成
        </Button>
    </PageContainer>
  );
};

export default MailTemplatePage;
